












import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { ENROLLMENT, SITE_LANG, ACCESS_TOKEN } from "../store/getters.names";
import { Enrollment } from "../store/store.types";
import { namespaced, NS_PUBLIC } from "../store/namespace";
import Navbar from "../components/Navbar.vue";
// import Video from "../components/Video.vue";
import {
  FETCH_LESSON_CONTENT,
  MARK_LESSON_COMPLETE
} from "../store/actions.names";
import axios from "axios";
import { ENROLLMENT_ENDPOINT } from "../store/endpoints";
import { generateAuthHeader } from "../utils/auth";
import VideoContent from "../components/contentViewers/VideoContent.vue";
import ExamContent from "../components/contentViewers/ExamContent.vue";
import TextContent from "../components/contentViewers/TextContent.vue";
import {
  FETCH_EXAM,
  MARK_EXAM_COMPLETE,
  FETCH_ENROLLMENT,
  FETCH_COURSES,
  FETCH_COURSE
} from "../store/actions.names";

@Component({
  name: "ReplayLessonView",
  components: {
    Navbar,
    videocontent: VideoContent,
    examcontent: ExamContent,
    textcontent: TextContent
  }
})
export default class LessonView extends Vue {
  @Getter(SITE_LANG) siteLang!: string;
  @Getter(ACCESS_TOKEN) accessToken!: string;
  @Action(namespaced(NS_PUBLIC, FETCH_LESSON_CONTENT))
  fetchLessonContent: any;
  @Action(namespaced(NS_PUBLIC, FETCH_ENROLLMENT)) fetchEnrollment: any;
  @Action(namespaced(NS_PUBLIC, FETCH_EXAM))
  fetchExam: any;
  @Action(namespaced(NS_PUBLIC, MARK_LESSON_COMPLETE))
  markLessonComplete: any;
  @Action(namespaced(NS_PUBLIC, MARK_EXAM_COMPLETE))
  markExamComplete: any;
  @Action(namespaced(NS_PUBLIC, FETCH_COURSE)) fetchCourse: any;
  public showBox: boolean = false;
  contentType: string | null = null;
  course: any = null;
  content: any = null;
  contentIndex: number = 0;
  enrollment: any | null = null;

  setContent() {
    this.fetchCourse({ slug: this.$route.params.courseSlug, refresh: false })
      .then(data => {
        this.course = data;
        if (data.enrollment !== null) {
          this.fetchEnrollment({
            enrollmentID: data.enrollment.id,
            refresh: false
          }).then(d => {
            this.enrollment = d;
            const progress_ids = this.enrollment.progress.map((val: any) => {
              return val.main_content;
            });
            const content = this.course.contents.find(
              val => val.id == this.$route.params.contentID
            );
            if (
              content != undefined &&
              content.type == "lesson" &&
              progress_ids.indexOf(content.id) != -1
            ) {
              this.fetchLessonContent(content.content).then(dd => {
                this.content = dd;
                this.contentIndex = 0;
                this.contentType = content.type;
              });
            }
          });
        }
      })
      .catch((e: any) => {
        // console.log(e);
      });
  }

  completeHandler(e) {
    // console.log(e);
    let safeToProceed = false;
    const content_type = this.content.contents[this.contentIndex].content_type;
    if (content_type !== "exam") {
      safeToProceed = true;
    } else {
      if (typeof e.result_id == "number") {
        safeToProceed = true;
      }
    }
    // console.log(safeToProceed);
    if (safeToProceed) {
      this.$router.push({
        name: "course-objectives",
        params: { courseSlug: this.$route.params.courseSlug }
      });
    }
  }

  mounted() {
    this.setContent();
  }
}
